import { render, staticRenderFns } from "./TransporterReports.vue?vue&type=template&id=663b4a47&scoped=true"
import script from "./TransporterReports.vue?vue&type=script&lang=js"
export * from "./TransporterReports.vue?vue&type=script&lang=js"
import style0 from "./TransporterReports.vue?vue&type=style&index=0&id=663b4a47&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663b4a47",
  null
  
)

export default component.exports